<template>
  <OrCardV3 class="flex h-[52px] w-full gap-[0px] overflow-hidden">
    <div class="flex flex-row items-center typography-body-2-regular text-on-background dark:text-on-background-dark">
      <div class="flex w-3/12 items-center px-sm">
        <OrTextV3
          :text="queue.name"
          data-test="queue-name"
        />
      </div>
      <div
        class="flex w-1/5 items-center px-sm"
        data-test="redrive-policy-cell"
      >
        {{ queue.redrivePolicy && 'Enabled' || 'Disabled' }}
      </div>
      <div
        class="flex w-1/5 items-center px-sm"
        data-test="mrt-cell"
      >
        {{ queue.mrt }}
      </div>
      <div class="flex w-1/5 items-center truncate px-sm">
        <OrDateTimeFormatV3
          v-model="dateCreated"
          data-test="date-created-cell"
        />
      </div>
      <div class="flex flex-row items-center gap-md px-sm">
        <OrIconButtonV3
          icon="info"
          data-test="info-icon-button"
          @click="$emit('openInfo', queue)"
        />
        <OrIconButtonV3
          icon="monitor_heart"
          data-test="monitor-heart-icon-button"
          @click="$emit('openMonitoring', queue)"
        />
        <OrIconButtonV3
          icon="edit"
          data-test="edit-icon-button"
          @click="$emit('openEdit', queue)"
        />
        <OrIconButtonV3
          icon="delete"
          data-test="delete-icon-button"
          @click="$emit('delete', queue)"
        />
      </div>
    </div>
  </OrCardV3>
</template>
<script lang="ts">
import {
  OrCardV3,
  OrIconButtonV3,
  OrDateTimeFormatV3,
  OrTextV3,
} from '@onereach/ui-components';
import useVuelidate from '@vuelidate/core';
import _ from 'lodash';
import { defineComponent, PropType } from 'vue';

import { Queue } from '../../types';


export default defineComponent({
  name: 'QueuesListItem',
  components: {
    OrCardV3,
    OrIconButtonV3,
    OrDateTimeFormatV3,
    OrTextV3,
  },
  props: {
    queue: {
      type: Object as PropType<Queue>,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
    isReadonly: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['openInfo', 'openMonitoring', 'openEdit', 'delete'],
  setup() {
    return {
      v$: useVuelidate(),
    };
  },
  data(props) {
    return {
      localValue: _.cloneDeep(props.queue),
      isEditing: false,
    };
  },
  computed: {
    dateCreated(): Date|null {
      if (this.queue.dateCreated) {
        return new Date(this.queue.dateCreated);
      } else { return null;}
    },
  },
  watch: {
    queue(val) {
      this.localValue = _.cloneDeep(val);
    },
  },
});
</script>
